import _jqueryDaterangepicker from "./src/jquery.daterangepicker.js";
_jqueryDaterangepicker;
export default {};